(function () {
  var loaderScript = document.currentScript;
  var source = loaderScript ? loaderScript.dataset.swiperSource : '';
  var promise;

  window.loadThemeSwiper = function () {
    if (typeof window.Swiper === 'function') return Promise.resolve(window.Swiper);
    if (promise) return promise;

    promise = new Promise(function (resolve, reject) {
      var script = document.querySelector('script[data-theme-swiper-library="true"]');
      var handleLoad = function () {
        if (typeof window.Swiper === 'function') {
          resolve(window.Swiper);
        } else {
          promise = null;
          reject(new Error('Swiper loaded without exposing its constructor.'));
        }
      };
      var handleError = function () {
        promise = null;
        reject(new Error('Unable to load the theme Swiper library.'));
      };

      if (script) {
        script.addEventListener('load', handleLoad, { once: true });
        script.addEventListener('error', handleError, { once: true });
        return;
      }

      if (!source) {
        promise = null;
        reject(new Error('The theme Swiper source is missing.'));
        return;
      }

      script = document.createElement('script');
      script.src = source;
      script.dataset.themeSwiperLibrary = 'true';
      script.addEventListener('load', handleLoad, { once: true });
      script.addEventListener('error', handleError, { once: true });
      document.head.appendChild(script);
    });

    return promise;
  };

  window.dispatchEvent(new CustomEvent('theme:swiper-loader-ready'));
})();
